// src/tools/ToolPage.tsx
import React from 'react';
import { useParams, Navigate } from 'react-router-dom';
import { getTool } from './registry';
import { ToolHeader, ToolTitle, ToolSubtitle } from './ui';

const ToolPage: React.FC = () => {
  const { slug } = useParams();
  const tool = getTool(slug);

  if (!tool) return <Navigate to="/tools" replace />;

  const { Component } = tool;

  return (
    <>
      <ToolHeader>
        <ToolTitle>
          <tool.icon /> {tool.name}
        </ToolTitle>
        <ToolSubtitle>{tool.description}</ToolSubtitle>
      </ToolHeader>
      <Component />
    </>
  );
};

export default ToolPage;
